/*eslint-disable*/
import React, {useEffect, useCallback, useState} from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";

import api from '../../services/api';

const useStyles = makeStyles(styles);

export default function Subcategory({category, value, handleChangeValue, marginTop}) {

  useEffect(() => {
      loadSubcategories();
  },[category]);

  const [subcategories, setSubcategories] = useState([]);

  const loadSubcategories = useCallback(async() => {
    try {
      
      const response = await api.get("/subcategories", {
        params: {
            category_id: category != "T" ? category : null
        } 
      });
      setSubcategories(response.data);
    }
    catch(e){

    }
  },[category]);

  const classes = useStyles();

  return (
    <FormControl fullWidth variant="outlined" className={classes.formControl} style={{marginTop: marginTop}}>
    <InputLabel id="subcategory">Subcategoria</InputLabel>             
       <Select 
            labelId="subcategory"
            label="subcategoria"
            variant="outlined"                  
            name="subcategory"
            fullWidth
            value={value ? value : 'T'}
            onChange={(e) => handleChangeValue(e.target.value)}              
            >    
            <MenuItem key="T" value="T">Selecione</MenuItem>                                   
            {subcategories.map(subcategory => {
               return <MenuItem key={subcategory.id} value={subcategory.id}>{subcategory.name}</MenuItem>        
            })}                               
      </Select>
   </FormControl>
  );
}
